// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import echarts from 'echarts'
import store from './store/index';
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
import './assets/iconfont/iconfont.js'
import { post, get, postArr, postArr1, getImg, put, deleteArr } from './api/api.js'

import TEditor from './components/mycomponents/tinymce/tinymce.vue'
Vue.component('TinymceEditor', TEditor)

Vue.use(ElementUI);
Vue.use('Message');
// Vue.prototype.api = 'http://172.16.0.59:8801/api';
// Vue.prototype.api = process.env.BASE_API 
// Vue.prototype.api = process.env.NODE_ENV === 'production'  ?  process.env.BASE_API  :  "http://172.16.0.55:8801/api";
Vue.prototype.api = process.env.BASE_API;
Vue.prototype.$echarts = echarts;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$getImg = getImg;
Vue.prototype.$postArr = postArr;
Vue.prototype.$postArr1 = postArr1;
Vue.prototype.$delete = deleteArr;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js